export enum ProgramMainMedicinesTableColumnTitle {
  ProtectedDrugName = "Zaštićeni naziv lijeka",
  Type = "Vrsta",
  Inn = "INN",
  UsageRegime = "Režim doziranja",
  UsageDayPeriod = "Doba dana uzimanja",
  Option = "",
}
